import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { TextField } from "@mui/material";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
const dateOption = {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
  hour12: false,
  timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  timeZoneName: "short",
};
export default function CustomDatePicker({
  available_until,
  onDateChange,
  theme,
}) {
  const [open, setOpen] = useState(false);
  const iconRef = useRef(null);
  return (
    <div>
      <MoreTimeIcon
        ref={iconRef}
        style={{
          color: theme.palette.primary.main,
          marginRight: theme.spacing(1),
          cursor: "pointer",
          marginTop: theme.spacing(1),
        }}
        fontSize="large"
        onClick={() => setOpen(true)}
      />

      <DesktopDatePicker
        open={open}
        onClose={() => setOpen(false)}
        value={new Date(available_until).toLocaleString("en-US", dateOption)}
        onChange={(newValue) => {
          const finalDateTime = new Date(newValue);
          finalDateTime.setHours(23, 59, 0, 0);
          onDateChange(finalDateTime);
          setOpen(false);
        }}
        slotProps={{
          toolbar: {
            toolbarPlaceholder: "__",
            toolbarFormat: "dd / MM / yyyy",
            hidden: false,
          },
          textField: {
            style: { display: "none" },
          },
          popper: {
            sx: {
              top: "50% !important",
              left: "50% !important",
              transform: "translate(-50%, -50%) !important",
            },
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            inputRef={iconRef}
            style={{
              position: "absolute",
              opacity: 0,
              pointerEvents: "none",
              height: 0,
              width: 0,
            }}
          />
        )}
        minDate={new Date(available_until)}
      />
    </div>
  );
}

CustomDatePicker.propTypes = {
  available_until: PropTypes.any,
  onDateChange: PropTypes.func.isRequired,
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      primary: PropTypes.shape({
        main: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    spacing: PropTypes.func.isRequired,
  }).isRequired,
};
